import { Box, Text } from '@air/zephyr';
import Image from 'next/image';

import { Container } from '~/old-marketing/components/Container';
import { AdobeSplashHeroTemplateImage } from '~/old-marketing/components/heros/templates/AdobeSplashHeroTemplateImage';
import { Section } from '~/old-marketing/components/Section';
import { buttonLinkRenderer } from '~/old-marketing/utils/buttonLinkRenderer';

export type AdobeSplashHeroTemplateProps = {
  content: string;
  title: string;
};

export const AdobeSplashHeroTemplate = ({ content, title }: AdobeSplashHeroTemplateProps) => {
  return (
    <>
      <Box tx={{ zIndex: -1, position: 'absolute', height: '100%', width: '100%', overflow: 'hidden' }}>
        <Box tx={{ zIndex: -1, position: 'absolute', top: '23.2vw', left: '-30vw', width: '250vw' }}>
          <Image height={1678} src="/assets/marketing/adobe-splash-background-image-1.svg" width={3612} />
        </Box>
      </Box>
      <Section tx={{ pt: [176, 176, 176], pb: [80, 156, 156], overflow: 'visible' }}>
        <Container>
          <Box tx={{ maxWidth: 782, mx: 'auto', mb: 80, textAlign: 'center' }}>
            {title && (
              <Text
                as="h1"
                tx={{ marginBottom: 'clamp(24px, 2.7vw, 40px)', color: 'jay050', fontSize: 'clamp(40px, 5vw, 72px)' }}
                dangerouslySetInnerHTML={{ __html: title }}
                variant="text-heading-72"
              />
            )}

            {content && (
              <Text
                as="p"
                tx={{
                  color: 'jay150',
                  marginBottom: 56,
                  fontSize: 'clamp(18px, 2.2vw, 32px)',
                }}
                variant="text-ui-32"
              >
                {content}
              </Text>
            )}

            {buttonLinkRenderer({
              children: 'Chat with sales',
              href: '#demo',
              size: 'large',
              type: 'external',
            })}
          </Box>
          <AdobeSplashHeroTemplateImage />
        </Container>
      </Section>
    </>
  );
};

AdobeSplashHeroTemplate.templateKey = 'adobe-splash-hero-template';
